import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import LoadingPlaceHolder from '../../../components/LoadingPlaceHolder';
import { useStorageContacts } from './queries';

function StorageContacts() {
  const { isFetching: isFetchingContacts, data: contactsData } =
    useStorageContacts();

  let moveCoordinator = null;
  let moveConsultant = null;
  if (contactsData?.contacts?.length) {
    const {
      MCEmail,
      MCFullName,
      MCPhoneNumber,
      RepEmail,
      RepFullName,
      RepPhoneNumber,
    } = contactsData.contacts[0];

    moveCoordinator = {
      email: MCEmail,
      fullName: MCFullName,
      phoneNumber: MCPhoneNumber,
    };

    moveConsultant = {
      email: RepEmail,
      fullName: RepFullName,
      phoneNumber: RepPhoneNumber,
    };
  }

  return (
    <div className="portal-inner has-tabs">
      <Row>
        <Col xl={9}>
          <div className="info-box">
            <div className="info-header">
              <h3>Contacts</h3>
            </div>
            <div className="info-content">
              {isFetchingContacts && <LoadingPlaceHolder isVisible />}
              {contactsData?.contacts?.length && (
                <div>
                  <h3>Move Coordinator</h3>
                  {moveCoordinator && (
                    <>
                      <div className="mb-3">
                        <FontAwesomeIcon icon={faUser} />{' '}
                        {moveCoordinator.fullName}
                      </div>
                      <div className="mb-3">
                        <FontAwesomeIcon icon={faEnvelope} />{' '}
                        <a href={`mailto:${moveCoordinator.email}`}>
                          {moveCoordinator.email}
                        </a>
                      </div>
                      {moveCoordinator.phoneNumber && (
                        <div className="mb-3">
                          <FontAwesomeIcon icon={faPhone} />{' '}
                          <a href={`tel:${moveCoordinator.PhoneNumber}`}>
                            {moveCoordinator.phoneNumber}
                          </a>
                        </div>
                      )}
                    </>
                  )}

                  <hr />

                  <h3>Move Consultant</h3>
                  {moveConsultant && (
                    <>
                      <div className="mb-3">
                        <FontAwesomeIcon icon={faUser} />{' '}
                        {moveConsultant.fullName}
                      </div>
                      <div className="mb-3">
                        <FontAwesomeIcon icon={faEnvelope} />{' '}
                        <a href={`mailto:${moveConsultant.email}`}>
                          {moveConsultant.email}
                        </a>
                      </div>
                      {moveConsultant.phoneNumber && (
                        <div className="mb-3">
                          <FontAwesomeIcon icon={faUser} />{' '}
                          <FontAwesomeIcon icon={faPhone} />{' '}
                          <a href={`tel:${moveConsultant.PhoneNumber}`}>
                            {moveConsultant.phoneNumber}
                          </a>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default StorageContacts;
